import React, { useState, useEffect } from 'react';
import { apiClient } from '../../api/client';

const AURA_STYLES = {
  '#FFD700': { shadow: '0 0 20px 6px rgba(255, 215, 0, 0.4)', border: 'border-yellow-400' },
  '#34D399': { shadow: '0 0 20px 6px rgba(52, 211, 153, 0.4)', border: 'border-emerald-400' },
  '#60A5FA': { shadow: '0 0 20px 6px rgba(96, 165, 250, 0.4)', border: 'border-blue-400' },
  '#A78BFA': { shadow: '0 0 20px 6px rgba(167, 139, 250, 0.4)', border: 'border-violet-400' },
  '#F9A8D4': { shadow: '0 0 20px 6px rgba(249, 168, 212, 0.4)', border: 'border-pink-300' },
};

const MoodAuraRing = ({ children, className = '', extra = null }) => {
  const [aura, setAura] = useState(null);

  useEffect(() => {
    apiClient.request('/api/advanced-engagement/mood-aura')
      .then(data => {
        if (data?.aura) setAura(data.aura);
      })
      .catch(() => {});
  }, []);

  const glowColor = aura?.glow || '#60A5FA';
  const style = AURA_STYLES[glowColor] || AURA_STYLES['#60A5FA'];

  return (
    <div
      className={`relative ${className}`}
      data-testid="mood-aura-ring"
      style={{ boxShadow: aura ? style.shadow : 'none' }}
    >
      {children}
      {(aura || extra) && (
        <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 z-30 flex items-center gap-1.5 whitespace-nowrap">
          {extra}
          {aura && (
            <div
              className="px-2 py-0.5 rounded-full text-[9px] font-bold text-white whitespace-nowrap"
              style={{ backgroundColor: glowColor }}
              data-testid="mood-aura-label"
            >
              {aura.label}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MoodAuraRing;
